export default /* html */ `
<ui-page>
  <ui-page-body>
    <ui-page-content>
      <div class="content">
        <div class="brand-name">
          <ui-heading class="heading" type="h1">Digial branch</ui-heading>

          <span class="payoff">Growing the internet</span>
        </div>
      </div>
    </ui-page-content>
  </ui-page-body>
</ui-page>
`
